<template>
    <v-container>
        <v-row class="d-flex justify-center black--text my-4">
            <h1><i class="fas fa-envelope"></i> Correos</h1>
        </v-row>
        <v-row class="d-flex justify-center mt-4 table-admins">
            {{ search }}
            <v-data-table
                :headers="headers"
                :items="emailResults"
                :loading="isLoading"
                :options.sync="options"
                :search="search"
                :server-items-length="totalEmailResults"
                class="datatable-admins"
            >
                <template v-slot:top>
                    <v-select
                        v-model="electionIdSelected"
                        :item-text="textItemElection"
                        :items="elecciones"
                        :loading="isLoading"
                        class="mx-4"
                        item-value="id"
                        label="Selecciona elección"
                        @change="onChangeElection"
                    >
                    </v-select>
                    <v-text-field
                        v-model="search"
                        class="mx-4"
                        label="Buscar"
                    ></v-text-field>
                </template>
            </v-data-table>
        </v-row>
    </v-container>
</template>

<script>
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import debouncer from '@/helpers/debouncer';

export default {
    computed: {
        ...mapGetters({
            elecciones: 'elecciones/elecciones',
            _emailResults: 'emails/emailResults',
            totalEmailResults: 'emails/totalEmailResults',
        }),
        emailResults() {
            return this.electionIdSelected ? this._emailResults : [];
        },
    },
    components: {
        ScaleLoader,
    },
    data() {
        return {
            headers: [
                {
                    text: 'Fecha',
                    value: 'created_at',
                    sortable: false,
                },
                {
                    text: 'Código',
                    value: 'code',
                    sortable: false,
                },
                {
                    text: 'Correo',
                    value: 'email',
                    sortable: false,
                },
                {
                    text: 'Estatus',
                    value: 'status',
                    sortable: false,
                },
            ],
            search: '',
            electionIdSelected: '',
            isLoading: true,
            perPage: 10,
            currentPage: 1,
            pageCount: 0,
            options: { page: 1, itemsPerPage: 10 },
        };
    },
    watch: {
        options: {
            handler() {
                this.loadEmails();
            },
            deep: true,
        },
        search: {
            immediate: false,
            handler: debouncer(function() {
                this.loadEmails();
            }, 800),
        },
    },
    methods: {
        onChangeElection() {
            this.loadEmails();
        },
        loadEmails() {
            if (this.electionIdSelected == '') {
                return;
            }

            const { sortBy, sortDesc, page, itemsPerPage } = this.options;

            this.isLoading = true;
            this.$store
                .dispatch('emails/getEmailResults', {
                    electionId: this.electionIdSelected,
                    search: this.search,
                    limit: itemsPerPage,
                    skip: (page - 1) * itemsPerPage,
                    search: this.search,
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(_ => {
                    this.isLoading = false;
                });
        },
        textItemElection: item =>
            `${item.id} | ${item.description} | ${item.type.toUpperCase()}`,
    },
    created() {
        this.isLoading = true;
        this.$store.dispatch('elecciones/getElecciones').finally(_ => {
            this.isLoading = false;
        });
    },
};
</script>

<style lang="scss"></style>
